import { latamCountries, menaRegions } from './constants/regions.constant';

function getContentfulConfig(
    shouldUseProxy: boolean,
    proxyUrl: string,
    language: string,
    urlLocale: string,
    country: string,
) {
    const contentFulConfigurations = {
        CONTENTFUL_SPACE_ID: 'vhp9jnid12wf',
    };

    let contentfulLocale = urlLocale;

    const excludedLocales = [
        'es-US',
        'es-MX',
        'es-ES',
        'fr-BE',
        'fr-CA',
        'fr-FR',
        'fr-CH',
        'fr-AD',
        'fr-BE',
        'fr-BL',
        'fr-GF',
        'fr-PF',
        'fr-TF',
        'fr-GP',
        'fr-MQ',
        'fr-MF',
        'fr-YT',
        'fr-NC',
        'fr-RE',
        'fr-PM',
    ];

    const isMenaRegion = menaRegions.indexOf(country.toUpperCase()) > -1;
    const isLatamRegion = latamCountries.indexOf(country.toUpperCase()) > -1;

    if (language.toLowerCase() === 'es' && isLatamRegion) {
        contentfulLocale = 'es-MX';
    } else if (
        language.toLowerCase() === 'es' &&
        !excludedLocales.includes(urlLocale)
    ) {
        contentfulLocale = 'es-LA';
    } else if (language.toLowerCase() === 'ar' && isMenaRegion) {
        contentfulLocale = 'ar-SA';
    } else if (language.toLowerCase() === 'ar') {
        contentfulLocale = 'ar-MA';
    } else if (language.toLowerCase() === 'he') {
        contentfulLocale = 'he-IL';
    } else if (language.toLowerCase() === 'en' && isLatamRegion) {
        contentfulLocale = 'en-MX';
    } else if (
        language.toLowerCase() === 'fr' &&
        !excludedLocales.includes(urlLocale)
    ) {
        contentfulLocale = 'fr-ZA';
    }

    const space = contentFulConfigurations.CONTENTFUL_SPACE_ID;

    return {
        space,
        shouldUseProxy,
        proxyUrl,
        contentfulLocale,
    };
}

export { getContentfulConfig };
